import { useTranslation } from "react-i18next";
import ActionButtonLayout from "./ActionButtonLayout";

import ExcelIcon from "../presentation/ExcelIcon";

function EstimateDownloadButtonLayout(props) {
    const { t } = useTranslation();

    const { ...others } = props;

    return (
        <ActionButtonLayout startIcon={<ExcelIcon />} {...others}>
            {t("buttonName.estimateDownload")}
        </ActionButtonLayout>
    );
}

export default EstimateDownloadButtonLayout;
